import { css } from 'styled-components';
import brand from './brand';
const scrollBarStyles = css `
  &::-webkit-scrollbar-track {
    background-color: var(--trackColour);
  }

  &::-webkit-scrollbar {
    background-color: var(--trackColour);
    height: var(--trackSize);
    width: var(--trackSize);
  }

  &::-webkit-scrollbar-thumb {
    background-color: var(--thumbColour);
    border-radius: 0;
    cursor: pointer;
  }
`;
/* For areas where scrollbar styles should always be used (eg. Moments Magazine issues list) */
export const scrollBarsAll = scrollBarStyles;
export default css `
  --thumbColour: ${brand.greenBright};
  --trackColour: ${brand.beige};
  --trackSize: 6px;

  /* @note: This is an attempt to use default scrollbars on touch devices */
  @media (hover: hover) or (pointer: fine) {
    ${scrollBarStyles};
  }
`;
